import { Radio as MuiRadio, type RadioProps as MuiRadioProps } from '@mui/material';

import {
  Radio24,
  RadioDisabled24,
  RadioSelected24,
  RadioDisabledSelected24,
} from '@packages/themes/icons';

export type RadioProps = MuiRadioProps;

export const Radio = (props: MuiRadioProps) => {
  const { disabled } = props;

  return (
    <MuiRadio
      icon={disabled ? <RadioDisabled24 /> : <Radio24 />}
      checkedIcon={disabled ? <RadioDisabledSelected24 /> : <RadioSelected24 />}
      disableFocusRipple
      {...props}
      data-testid="mui-radio"
    />
  );
};
